module.exports = __webpack_public_path__ + "static/longshore-logo-15ec92583948d2c52f7b34077ab1f858.jpeg";